import { StoreStepInterface } from '@hb/modules/global';
import { AccordionStateService } from '@hb/services/accordion-state/accordion-state.service';
import { StoreService } from '@hb/services/store/store.service';

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';

@Injectable()
export abstract class AbstractStoreStepInject implements StoreStepInterface {
    protected abstract readonly storeService: StoreService;
    protected abstract readonly accordionStateService: AccordionStateService;

    activeOptionSubject: BehaviorSubject<number>;
    summary: number;

    backOption(back = 1): void {
        const nextQuestion = this.activeOptionSubject.value - back;
        if (nextQuestion === -1) {
            this.accordionStateService.stepBack();
        } else if (this.isActiveOption(nextQuestion)) {
            this.activeOptionSubject.next(nextQuestion);
        } else {
            this.backOption(back + 1);
        }
    }

    getHasCoApplicant(): Observable<boolean> {
        return this.storeService.getHasCoApplicant();
    }

    nextOption(next = 1): void {
        if (this.activeOptionSubject.value !== this.summary) {
            const nextQuestion = this.activeOptionSubject.value + next;
            if (nextQuestion === this.summary) {
                this.storeService.nextStep();
                this.activeOptionSubject.next(this.summary);
            } else if (this.isActiveOption(nextQuestion)) {
                this.activeOptionSubject.next(nextQuestion);
            } else {
                this.nextOption(next + 1);
            }
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isActiveOption(nextQuestion: number): boolean {
        throw new Error('Method not implemented.');
    }

    isSummary(): Observable<boolean> {
        return this.getActiveOption().pipe(map((option) => option === this.summary));
    }

    getActiveOption(): Observable<number> {
        return this.activeOptionSubject.asObservable();
    }
}
